import { render, staticRenderFns } from "./mainCategoryManage.vue?vue&type=template&id=1d4404b6&scoped=true"
import script from "./mainCategoryManage.vue?vue&type=script&lang=js"
export * from "./mainCategoryManage.vue?vue&type=script&lang=js"
import style0 from "./mainCategoryManage.vue?vue&type=style&index=0&id=1d4404b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4404b6",
  null
  
)

export default component.exports